export default [
  // chart of accounts
  {
    path: "/accounting/coa",
    name: "ChartOfAccounts",
    component: () => import("@/pages/accounting/ChartOfAccountsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/coa/new",
    name: "NewCOA",
    component: () => import("@/pages/accounting/NewCOAPage.vue"),
    meta: { requiresAuth: true },
  },
  // ledgers
  {
    path: "/accounting/ledgers",
    name: "Ledgers",
    component: () => import("@/pages/accounting/LedgersPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/ledgers/account/:code",
    name: "AccountLedgers",
    component: () => import("@/pages/accounting/AccountLedgersPage.vue"),
    meta: { requiresAuth: true },
  },
  // journal entries
  {
    path: "/accounting/transactions",
    name: "AccountingTransactions",
    component: () => import("@/pages/accounting/TransactionsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/transactions/account/:code",
    name: "AccountTransactions",
    component: () => import("@/pages/accounting/AccountTransactionsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/expenses/new",
    name: "NewExpenseTransaction",
    component: () => import("@/pages/accounting/NewExpenseTransactionPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/invoices",
    name: "Invoices",
    component: () => import("@/pages/accounting/InvoicesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/invoice/:invoiceNumber",
    name: "Invoice",
    component: () => import("@/pages/accounting/InvoiceDetailsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/expenses",
    name: "Expenses",
    component: () => import("@/pages/accounting/ExpenseTransactionsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/payable",
    name: "AccountsPayable",
    component: () => import("@/pages/accounting/InvoicesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/receivable",
    name: "AccountsReceivable",
    component: () => import("@/pages/accounting/InvoicesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/receivable/payment",
    name: "ReceivablePayment",
    component: () => import("@/pages/accounting/ReceivablePaymentPage.vue"),
    meta: { requiresAuth: true },
  },
  // assets
  {
    path: "/accounting/banks",
    name: "Banks",
    component: () => import("@/pages/accounting/BanksPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/banks/new",
    name: "NewBank",
    component: () => import("@/pages/accounting/NewBankPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/cash",
    name: "Cashs",
    component: () => import("@/pages/accounting/CashsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/cash/new",
    name: "NewCash",
    component: () => import("@/pages/accounting/NewCashPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/mfs",
    name: "MFSs",
    component: () => import("@/pages/accounting/MFSsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/mfs/new",
    name: "NewMFS",
    component: () => import("@/pages/accounting/NewMFSPage.vue"),
    meta: { requiresAuth: true },
  },
  // next release
  {
    path: "/accounting/tax-management",
    name: "TaxManagement",
    component: () => import("@/pages/accounting/TaxManagementPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/payroll",
    name: "Payroll",
    component: () => import("@/pages/accounting/PayrollPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/reports",
    name: "FinancialReports",
    component: () => import("@/pages/accounting/FinancialReports.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting/budgets",
    name: "Budgets",
    component: () => import("@/pages/accounting/BudgetsPage.vue"),
    meta: { requiresAuth: true },
  },
];